"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var InfoBar_1 = require("owa-info-bar/lib/components/InfoBar");
var InfoBarMessageViewState_1 = require("owa-info-bar/lib/schema/InfoBarMessageViewState");
var owa_messagead_strings_1 = require("owa-strings/owa-messagead-strings");
var React = require("react");
var styles = require('./MessageAdReadingPane.scss');
var ItemHeaderInfoBar = /** @class */ (function (_super) {
    tslib_1.__extends(ItemHeaderInfoBar, _super);
    function ItemHeaderInfoBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemHeaderInfoBar.prototype.render = function () {
        var infoBarMessageViewState = {
            key: 'MessageListAdDisclaimer',
            source: InfoBarMessageViewState_1.InfoBarMessageSource.ReadingPane,
            rank: InfoBarMessageViewState_1.InfoBarMessageRank.Info,
            messageParts: [owa_messagead_strings_1.default.adMessageInfobarDisclamer],
        };
        var infoBarViewState = {
            messages: [],
        };
        infoBarViewState.messages.push(infoBarMessageViewState);
        return React.createElement(InfoBar_1.default, tslib_1.__assign({}, infoBarViewState, { className: styles.infoBar }));
    };
    return ItemHeaderInfoBar;
}(React.Component));
exports.default = ItemHeaderInfoBar;
//# sourceMappingURL=ItemHeaderInfobar.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-readingpane-view/lib/components/ItemHeaderInfobar.js
// module id = 5558
// module chunks = 17